import { Button } from '@local/do-secundo-button'
import React, { useState } from 'react'
import { useCart } from '@local/do-secundo-cart-provider'
import { ShareCartModal } from './ShareCartModal'
import TooltipWrapper from '../Tooltip/TooltipWrapper'
import cx from 'classnames'
import { useRestaurant } from '@local/do-secundo-restaurant-provider'
import { t } from '@local/translations'

export const ShareCartButton = () => {
  const { cartGuid } = useCart()
  const {
    applicableConfigs: { sharedCartEnabled }
  } = useRestaurant()

  const [showShareCartModal, setShowShareCartModal] = useState(false)

  if (!sharedCartEnabled) {
    return null
  }

  const disabledSharedCart = !cartGuid

  return (
    <>
      <TooltipWrapper
        enableTooltip={disabledSharedCart}
        message={t('share-cart-button.select-date-time-tooltip')}
        placement={'top'}
      >
        <Button
          className={cx({ 'no-underline': disabledSharedCart })}
          disabled={disabledSharedCart}
          data-testid='share-cart-button'
          onClick={() => setShowShareCartModal(true)}
        >
          {t('share-cart-button.share-cart')}
        </Button>
      </TooltipWrapper>
      {showShareCartModal && (
        <ShareCartModal onClose={() => setShowShareCartModal(false)} />
      )}
    </>
  )
}
